module.exports = __webpack_public_path__ + "static/img/iphone_ldtpage2.e8b7da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldtpage2.png
// module id = pWdC
// module chunks = 0